<template>
  <NuxtLayout :name="layoutName">
    <ShoplinkLandingPage v-if="isLnkSubdomain && shortId" :short-id="shortId" />
    <div v-else class="flex flex-col items-center justify-center min-h-screen bg-[#0a0a0f] text-white p-4">
      <h1 class="text-6xl font-black mb-4 opacity-20">404</h1>
      <p class="text-xl font-medium text-white/50 mb-8">Page not found</p>
      <NuxtLink to="/" class="px-6 py-3 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all font-bold">
        Go Home
      </NuxtLink>
    </div>
  </NuxtLayout>
</template>

<script setup>
import ShoplinkLandingPage from '~/components/Shoplink/LandingPage.vue'

// Disable default layout since we'll wrap content manually with NuxtLayout
definePageMeta({
  layout: false
})

const route = useRoute()
const url = useRequestURL()
const host = url.hostname

// Logic for lnk subdomain
const isLnkSubdomain = computed(() => host.startsWith('lnk.'))
const shortId = computed(() => {
  const slug = route.params.slug
  if (Array.isArray(slug) && slug.length > 0) {
    return slug[0]
  }
  return route.path.replace(/^\//, '').split('/')[0] || ''
})

const layoutName = computed(() => (isLnkSubdomain.value && shortId.value) ? 'lnk' : 'default')

if (isLnkSubdomain.value) {
    console.log('[Routing] Lnk subdomain detected. Host:', host, 'shortId:', shortId.value)
}

// SEO
useHead({
  title: 'Diztree',
  meta: [
    { name: 'robots', content: 'noindex, nofollow' }
  ]
})
</script>
